import { render } from "./AuthUserComment.vue?vue&type=template&id=fc5112ee"
import script from "./AuthUserComment.vue?vue&type=script&lang=ts"
export * from "./AuthUserComment.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fc5112ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc5112ee', script)) {
    api.reload('fc5112ee', script)
  }
  
  module.hot.accept("./AuthUserComment.vue?vue&type=template&id=fc5112ee", () => {
    api.rerender('fc5112ee', render)
  })

}

script.__file = "src/views/AuthenticateUserPage/components/AuthUserComment.vue"

export default script